import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { EffectivenessScoreToLowToHighScalePipe } from "./pipes/effectiveness-score-to-low-to-high-scale.pipe";
import { LowToHighScaleEffectivenessToColorPipe } from "./pipes/low-to-high-scale-effectiveness-to-color.pipe";
import { LowToHighScaleEffectivenessToIconPipe } from "./pipes/low-to-high-scale-effectiveness-to-icon.pipe";
import { LowToHighScaleEffectivenessToLabelPipe } from "./pipes/low-to-high-scale-effectiveness-to-label.pipe";

@NgModule({
  imports: [CommonModule],
  declarations: [
    EffectivenessScoreToLowToHighScalePipe,
    LowToHighScaleEffectivenessToColorPipe,
    LowToHighScaleEffectivenessToLabelPipe,
    LowToHighScaleEffectivenessToIconPipe,
  ],
  exports: [
    EffectivenessScoreToLowToHighScalePipe,
    LowToHighScaleEffectivenessToColorPipe,
    LowToHighScaleEffectivenessToLabelPipe,
    LowToHighScaleEffectivenessToIconPipe,
  ],
})
export class PIExpandableSuggestionsSharedModule {}
